import React, { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import baseURL from '../component/baseURL';
import MyActiveFeedSidebar from './MyActiveFeedSidebar';
import Feed1 from './Feed1';
import Feed2 from './Feed2';
import Feed3 from './Feed3';
import Feed4 from './Feed4';
import Feed5 from './Feed5';
import PocketFeed from './PocketFeed';
import showNotification from '../component/Notification';
import {
    buildMyFeedActiveSubRouteState,
    isMyFeedActiveSubRoute,
    navigateFromMyFeedActiveHub,
} from '../utils/feedActiveNavigation';

const FEED_ITEMS = ['Feed 1', 'Feed 2', 'Feed 3', 'Feed 4', 'Feed 5', 'Pocket Feed'];
function isValidFeedItem(item) {
    return FEED_ITEMS.includes(item);
}

export default function MyFeedActive({ hideMobileHeader = false }) {

    const location = useLocation();
    const navigate = useNavigate();
    const [activeItem, setActiveItem] = useState("Feed 1");
    const [isMobilePageOpen, setIsMobilePageOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const gearMenuRef = useRef(null);
    const feedItemToPath = {
        'Feed 1': '/feed/my-feed-active/feed-1',
        'Feed 2': '/feed/my-feed-active/feed-2',
        'Feed 3': '/feed/my-feed-active/feed-3',
        'Feed 4': '/feed/my-feed-active/feed-4',
        'Feed 5': '/feed/my-feed-active/feed-5',
        'Pocket Feed': '/feed/my-feed-active/pocket-feed',
    };


    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const userID = localStorage.getItem('user_id');

    }, []);

    // Close gear dropdown on outside click (desktop)
    useEffect(() => {
        const handleGearClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleGearClickOutside);
        return () => document.removeEventListener('mousedown', handleGearClickOutside);
    }, []);

    const handleItemClick = (item) => {
        setActiveItem(item);

        // Use dedicated mobile URLs for each feed tab; keep desktop route as before.
        if (isMobile && feedItemToPath[item]) {
            navigate(feedItemToPath[item], {
                replace: true,
                state: buildMyFeedActiveSubRouteState(item, location.state?.returnTo),
            });
        } else {
            navigate('/feed/my-feed-active', { replace: true, state: { activeItem: item } });
        }

        // Notify App component about MyConnection view
        const isViewingMyConnection = item === "Feed 1";
        window.dispatchEvent(new CustomEvent('myConnectionView', {
            detail: { isViewing: isViewingMyConnection }
        }));

        if (isMobile) {
            setIsMobilePageOpen(true);
        }
    };

    // Notify on initial load
    useEffect(() => {
        const isViewingMyConnection = activeItem === "Feed 1";
        window.dispatchEvent(new CustomEvent('myConnectionView', {
            detail: { isViewing: isViewingMyConnection }
        }));
    }, [activeItem]);

    // Set initial tab when coming from other pages (e.g. MembersProfile back from Feeds Received)
    useEffect(() => {
        const fromState = location.state;
        if (isValidFeedItem(fromState?.activeItem)) {
            setActiveItem(fromState.activeItem);
            if (isMobile) {
                setIsMobilePageOpen(true);
            }
        } else if (location.pathname === '/feed/my-feed-active' && isMobile) {
            setIsMobilePageOpen(false);
        }
    }, [location.state, location.pathname, isMobile]);

    // Sync activeItem for My Feed Active route
    useEffect(() => {
        const path = location.pathname;
        if (path === '/feed/my-feed-active') {
            if (isValidFeedItem(location.state?.activeItem)) {
                setActiveItem(location.state.activeItem);
                if (isMobile) setIsMobilePageOpen(true);
            } else if (isMobile) {
                // Open sidebar first; enter Feed 1–5/Pocket only after explicit tab click.
                setIsMobilePageOpen(false);
            }
        } else if (path === '/feed/my-feed-active/feed-1') {
            setActiveItem('Feed 1');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/my-feed-active/feed-2') {
            setActiveItem('Feed 2');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/my-feed-active/feed-3') {
            setActiveItem('Feed 3');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/my-feed-active/feed-4') {
            setActiveItem('Feed 4');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/my-feed-active/feed-5') {
            setActiveItem('Feed 5');
            if (isMobile) setIsMobilePageOpen(true);
        } else if (path === '/feed/my-feed-active/pocket-feed') {
            setActiveItem('Pocket Feed');
            if (isMobile) setIsMobilePageOpen(true);
        } else if ((path === '/feed' || path === '/feed/') && !location.state?.activeItem) {
            setActiveItem('Feed 1');
        }
    }, [location.pathname, location.state?.activeItem, isMobile]);

    const handleBackClick = () => {
        setIsMobilePageOpen(false);
        navigateFromMyFeedActiveHub(navigate, location);
    };

    const openInfoModal = () => {
        setGearMenuOpen(false);
        setInfoModalOpen(true);
    };






    const renderContent = () => {
        switch (activeItem) {
            case "Feed 1":
                return <Feed1 />;
            case "Feed 2":
                return <Feed2 />;
            case "Feed 3":
                return <Feed3 />;
            case "Feed 4":
                return <Feed4 />;
            case "Feed 5":
                return <Feed5 />;
            case "Pocket Feed":
                return <PocketFeed />;
            default:
                return <Feed1 />;
        }
    };

    const hasMobileFeedSelection = isMobilePageOpen || isMyFeedActiveSubRoute(location.pathname);
    const isDedicatedFeedMobileRoute = isMyFeedActiveSubRoute(location.pathname);

    return (
        <section className="home">
            <div className="container my-feed-active-page-container">
                {isMobile && !hideMobileHeader && !isDedicatedFeedMobileRoute && (
                    <div className="mobile-page-header">
                        <button className="mobile-back-btn" onClick={handleBackClick}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M15 18L9 12L15 6"
                                    stroke="white"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                        <h2 className="mobile-page-title">My Feed Active</h2>
                    </div>
                )}
                <div className={`content-holder ${isMobile ? 'my-feed-active-page-mobile' : ''}`}>
                    <MyActiveFeedSidebar
                        activeItem={activeItem}
                        setActiveItem={handleItemClick}
                    />
                    <div className={`content-right-wrapper ${isMobilePageOpen ? 'mobile-page-open' : ''}`}>
                        {(!isMobile || hasMobileFeedSelection) && renderContent()}
                    </div>

                    {!isMobile && (
                        <div className="btn-section btn-section-gear" ref={gearMenuRef}>
                            <button
                                type="button"
                                className={`btn-primary gear-btn ${gearSpinning ? 'gear-spin' : ''}`}
                                onClick={() => {
                                    setGearMenuOpen((prev) => !prev);
                                    setGearSpinning(true);
                                    setTimeout(() => setGearSpinning(false), 500);
                                }}
                                aria-label="Open menu"
                                aria-expanded={gearMenuOpen}
                            >
                                <i className="fa-solid fa-gear"></i>
                            </button>
                            {gearMenuOpen && (
                                <ul className="gear-dropdown" aria-label="Information menu">
                                    <li>
                                        <button
                                            type="button"
                                            className="gear-dropdown-item"
                                            onClick={openInfoModal}
                                        >
                                            <i className="fa-solid fa-circle-info"></i>
                                            <span>Information</span>
                                        </button>
                                    </li>
                                </ul>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {isMobile && !isDedicatedFeedMobileRoute && (
                <nav className="mobile-bottom-nav liquidGlass-wrapper dock my-feed-active-footer-nav" aria-label="My Feed Active actions">
                    <div className="liquidGlass-effect" aria-hidden="true" />
                    <div className="liquidGlass-shine" aria-hidden="true" />
                    <div
                        className="mobile-nav-item"
                        role="button"
                        tabIndex={0}
                        aria-label="Information"
                        onClick={() => setInfoModalOpen(true)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setInfoModalOpen(true);
                            }
                        }}
                    >
                        <i className="fa-solid fa-info"></i>
                    </div>
                </nav>
            )}

            {infoModalOpen && (
                <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Information">
                    <div className="logout-modal">
                        <h2 className="text-white mb-2 text-lg">Information</h2>
                        <p className="text-white mb-4">
                            Feeds are a collection of listings that can be shared with your connections with one click. It saves time and effort compared to sharing one listing at a time.
                            <br />
                            <br />
                            It also has a subscribe feature that automatically suggests all new listings entered in this feed group to the feed connections.
                        </p>
                        <div className="btn-sec" style={{ justifyContent: 'center' }}>
                            <button type="button" className="save-btn" onClick={() => setInfoModalOpen(false)}>OK</button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    )
}